module.exports = __webpack_public_path__ + "img/avatar.cc0c4e88.png";